<div id="section1" style="height: 100vh;">
    <FRAMESET ROWS="100%,*" frameborder="no" framespacing=0 border=0>
        <FRAME SRC="http://content.gamezine.info/games/?url=https://gogames.run/h5games/games/BirdBlast/index.html&agency=ATECHNOS&dataResponse=Bird" NAME="mainwindow" frameborder="no" framespacing="0" marginheight="0" marginwidth="0"></FRAME>
    </FRAMESET>
</div>